var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
import { Headers, RequestOptions } from '@angular/http';
import { SharedService } from './shared.service';
import { environment } from '../environment';
var KeycloakService = KeycloakService_1 = (function () {
    function KeycloakService() {
        //console.log("new KeycloakService!");
        KeycloakService_1.instance = this;
    }
    KeycloakService.init = function () {
        //console.log("keycloaksevice url: " + window.location.href);
        var allowedUrlsWithoutAuth = ['/actuacion', '/enlace-no-autorizado', '/vinculacion-rep', '/desvinculacion-rep'];
        // Verifica si la ruta actual está en la lista de rutas permitidas sin autenticación
        if (allowedUrlsWithoutAuth.some(function (url) { return window.location.pathname.startsWith(url); })) {
            // No requiere autenticación para estas rutas
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
        var configUrl = environment['remoteConfig'] ? environment['remoteConfig'].toString() : "";
        // if "self" go to current backend
        if (configUrl.toLowerCase().indexOf("self") > -1) {
            configUrl = location.protocol + '//' + location.hostname;
            if (location.port && location.port == "3000") {
                configUrl = configUrl + ":8280/iol-ui";
            }
            else if (location.port) {
                configUrl = configUrl + ":" + location.port;
                // configUrl = configUrl + ":8081/iurix-services";
            }
            configUrl = configUrl +
                ((location.pathname.indexOf('/', 1) > 0) ?
                    location.pathname.substring(0, location.pathname.indexOf('/', 1)) : '')
                + "/api/env/";
        }
        //console.log("getting keycloak from " + configUrl);
        // return promise to main.ts
        return new Promise(function (resolve, reject) {
            var resolve1 = resolve;
            var reject1 = reject;
            // call restful using ajax
            $.ajax({
                type: "GET",
                dataType: 'json',
                url: configUrl,
                contentType: 'application/json; charset=utf-8',
                cache: false,
                success: function (result, status, xhr) {
                    //console.log(JSON.stringify(result));
                    // transitive config?
                    if (result["remoteConfig"]) {
                        var configUrl2 = result["remoteConfig"];
                        //console.log("transitive keycloak config: " + configUrl);
                        // re-call restful using ajax to new url
                        $.ajax({
                            type: "GET",
                            dataType: 'json',
                            url: configUrl2,
                            contentType: 'application/json; charset=utf-8',
                            cache: false,
                            success: function (result, status, xhr) {
                                var kconfig = {};
                                // from all env vars
                                Object.keys(result)
                                    .filter(function (key) { return key.startsWith("kc."); })
                                    .forEach(function (key) {
                                    kconfig[key.substring(3)] = result[key];
                                    //console.log(key.substring(3) + ": " + kconfig[key.substring(3)]);
                                });
                                // create keycloak object
                                KeycloakService_1.keycloakAuth = new Keycloak(kconfig);
                                KeycloakService_1.keycloakAuth.loggedIn = false;
                                //console.log("keycloak config loaded(2)!");
                                // login!
                                return new Promise(function (resolve, reject) {
                                    KeycloakService_1.keycloakAuth.init({ onLoad: 'login-required' })
                                        .success(function () {
                                        var redirectUri = encodeURIComponent(location.origin + "/" + location.pathname.substring(1).substring(0, location.pathname.substring(1).indexOf('/')));
                                        KeycloakService_1.auth.loggedIn = true;
                                        KeycloakService_1.auth.authz = KeycloakService_1.keycloakAuth;
                                        KeycloakService_1.auth.logoutUrl = KeycloakService_1.keycloakAuth.authServerUrl + "/realms/" + kconfig["realm"] + "/protocol/openid-connect/logout?redirect_uri=" + redirectUri;
                                        //console.log("authenticated: " + this.auth.authz.tokenParsed.preferred_username);
                                        // return to super-observer
                                        resolve1();
                                    })
                                        .error(function (error) {
                                        console.error("Error(3): " + JSON.stringify(error));
                                        // return to super-observer
                                        reject1();
                                    });
                                });
                            },
                            error: function (result, status, xhr) {
                                console.error("Error: " + JSON.stringify(status));
                                reject();
                            }
                        });
                    }
                    else {
                        var kconfig = {};
                        // from all env vars
                        Object.keys(result)
                            .filter(function (key) { return key.startsWith("kc."); })
                            .forEach(function (key) {
                            kconfig[key.substring(3)] = result[key];
                            //console.log(key.substring(3) + ": " + kconfig[key.substring(3)]);
                        });
                        // create keycloak object
                        KeycloakService_1.keycloakAuth = new Keycloak(kconfig);
                        KeycloakService_1.keycloakAuth.loggedIn = false;
                        //console.log("keycloak config loaded!");
                        // login!
                        return new Promise(function (resolve, reject) {
                            KeycloakService_1.keycloakAuth.init({ onLoad: 'login-required' })
                                .success(function () {
                                var redirectUri = encodeURIComponent(location.origin + "/" + location.pathname.substring(1).substring(0, location.pathname.substring(1).indexOf('/')));
                                KeycloakService_1.auth.loggedIn = true;
                                KeycloakService_1.auth.authz = KeycloakService_1.keycloakAuth;
                                KeycloakService_1.auth.logoutUrl = KeycloakService_1.keycloakAuth.authServerUrl + "/realms/" + kconfig["realm"] + "/protocol/openid-connect/logout?redirect_uri=" + redirectUri;
                                //console.log("authenticated: " + this.auth.authz.tokenParsed.preferred_username);
                                // return to super-observer
                                resolve1();
                            })
                                .error(function (error) {
                                console.error("Error(2): " + JSON.stringify(error));
                                // return to super-observer
                                reject1();
                            });
                        });
                    }
                },
                error: function (result, status, xhr) {
                    console.error("Error: " + JSON.stringify(status));
                    reject();
                }
            });
        });
    };
    KeycloakService.init2 = function () {
        if (!SharedService.isKCDevMode()) {
            KeycloakService_1.keycloakAuth = new Keycloak('keycloak.json');
            KeycloakService_1.auth.loggedIn = false;
            return new Promise(function (resolve, reject) {
                KeycloakService_1.keycloakAuth.init({ onLoad: 'login-required' })
                    .success(function () {
                    var redirectUri = encodeURIComponent(location.origin + "/" + location.pathname.substring(1).substring(0, location.pathname.substring(1).indexOf('/')));
                    KeycloakService_1.auth.loggedIn = true;
                    KeycloakService_1.auth.authz = KeycloakService_1.keycloakAuth;
                    KeycloakService_1.auth.logoutUrl = KeycloakService_1.keycloakAuth.authServerUrl + "/realms/" + SharedService.kcRealm() + "/protocol/openid-connect/logout?redirect_uri=" + redirectUri;
                    //console.log("authenticated: " + this.auth.authz.tokenParsed.preferred_username);
                    resolve();
                })
                    .error(function () {
                    reject();
                });
            });
        }
        else {
            //console.log("Keycloak in DEV mode (ignoring keycloak login)");
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
    };
    KeycloakService.prototype.logout = function () {
        KeycloakService_1.auth.loggedIn = false;
        KeycloakService_1.auth.authz = null;
        window.location.href = KeycloakService_1.auth.logoutUrl;
    };
    KeycloakService.getBearer = function () {
        if (!SharedService.isKCDevMode()) {
            if (KeycloakService_1.keycloakAuth.isTokenExpired(5)) {
                KeycloakService_1.keycloakAuth.updateToken(5).success(function (refreshed) {
                    if (refreshed) {
                        //console.log('Token was successfully refreshed');
                    }
                    else {
                        //console.log('Token is still valid');
                    }
                }).error(function () {
                    //console.error('Failed to refresh the token, or the session has expired');
                });
            }
            var headers = new Headers({ 'Authorization': 'Bearer ' + KeycloakService_1.auth.authz.token });
            // FIX: securizado KC off hasta resolver problemas para la subida de escritos y websocket
            return { "headers": headers };
        }
        else {
            return { "headers": new Headers({ 'Authorization': 'Bearer .' }) };
        }
    };
    KeycloakService.getLoggedUser = function () {
        if (!SharedService.isKCDevMode()) {
            return KeycloakService_1.auth.authz.tokenParsed.preferred_username;
        }
        else {
            //console.log("Keycloak in DEV mode (returning static user)");
            return "jorges";
        }
    };
    KeycloakService.setLoggedUser = function (usuario) {
        this.usr = usuario;
    };
    KeycloakService.prototype.getToken = function () {
        return new Promise(function (resolve, reject) {
            if (KeycloakService_1.auth.authz.token) {
                KeycloakService_1.auth.authz.updateToken(5)
                    .success(function () {
                    resolve(KeycloakService_1.auth.authz.token);
                })
                    .error(function () {
                    reject('Failed to refresh token');
                });
            }
        });
    };
    KeycloakService.getHeaderKey = function () {
        //console.log("token " + <string>KeycloakService.auth.authz.token);
        //let headers = new Headers({ 'Authorization': 'Bearer ' + <string>KeycloakService.auth.authz.token });
        var headers = new Headers({
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Authorization": "Bearer " + KeycloakService_1.auth.authz.token
        });
        // let headers = new Headers({
        //     'Accept': 'application/json',
        //     'Authorization': 'Bearer ' + KeycloakService.auth.authz.token
        // });
        return new RequestOptions({ headers: headers });
    };
    return KeycloakService;
}());
KeycloakService.auth = {};
KeycloakService = KeycloakService_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], KeycloakService);
export { KeycloakService };
function restfulCall(path, callback, errorCallback) {
    $.ajax({
        type: "POST",
        dataType: 'json',
        url: path,
        contentType: 'application/json; charset=utf-8',
        cache: false,
        success: callback,
        error: errorCallback
    });
}
var KeycloakService_1;
//# sourceMappingURL=keycloak.service.js.map